import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from '../master-data/product-entity';

export class ProductPage extends BaseEntity{
    
    productPageCode     : string;
    name                : string;
    loadable            : boolean;
    salable             : boolean;
    bonus               : boolean;
    freeGood            : boolean;
    presenceCheckable   : boolean;
    presenceCheckable2  : boolean;
    inventoryable       : boolean;
    inventoryable2      : boolean;
    inventoryable3      : boolean;
    facingable          : boolean;
    apos                : boolean;
    rank                : number;
    logo                : any;
    consignement        : number;
    photo               : any;

    products            : Product[];

}